import { Dispatch, SetStateAction } from "react";
import { useAtomValue } from "jotai";

import { isGlobalCloudAtom } from "../../../atoms/GlobalAtoms";
import { AllViewTypes } from "../../../types/PageInterfaces";
import AppFieldCard from "../../../elements/AppFieldCard";

export const ViewTypeData = (
  isAppBuilder?: boolean,
  isGlobalApp: boolean = false
) => {
  const ViewTypes = [
    {
      value: "Table",
      label: "Table",
      description:
        "Customizable table for displaying records in any Data Source",
      icon: "mdi mdi-table",
    },
    {
      value: "Cards",
      label: "Cards",
      description:
        "Customizable cards for displaying records in any Data Source",
      icon: "mdi mdi-card-multiple-outline",
    },
    {
      value: "Board",
      label: "Kanban Board",
      description:
        "Customizable drag and drop kanban board for organizing records by a selected field",
      icon: "mdi mdi-view-column",
    },
    {
      value: "Timeline",
      label: "Timeline",
      description:
        "Customizable drag and drop board specialized for date/time groupping",
      icon: "mdi mdi-timeline-clock-outline",
    },
    {
      value: "Dashboard",
      label: "Dashboard",
      description: "Custom view that allows you to place any number of Widgets",
      icon: "mdi mdi-view-dashboard",
    },
    {
      value: "FlowChart",
      label: "Flow Builder",
      description: "Create flow charts and business process flows",
      icon: "mdi mdi-sitemap",
    },
    {
      value: "Calendar",
      label: "Calendar",
      description: "Customizable calendar view to manage events",
      icon: "mdi mdi-calendar",
    },
    {
      value: "Document",
      label: "Document",
      description: "View dedicated to Rich Text editing",
      icon: "mdi mdi-file-document",
    },
    {
      value: "External",
      label: "External Link",
      description: "Place an external link in this Page's navbar.",
      icon: "mdi mdi-open-in-new",
    },
  ];

  if (isAppBuilder) {
    ViewTypes.push({
      value: "BrieGPT",
      label: "Brie GPTs",
      description: "Train your own custom GPTs",
      icon: "mdi mdi-robot-happy-outline",
    });
  }

  if (isGlobalApp) {
    ViewTypes.push({
      value: "ReuseView",
      label: "Reuse Views",
      description: "Reuse existing views in the current App",
      icon: "mdi mdi-share-variant",
    });
  }

  return ViewTypes;
};

const SubViewTypeData = [
  {
    value: "Gallery",
    label: "Document Library",
    description: "Display a record's attachment field as a File Gallery.",
    icon: "mdi mdi-image-multiple-outline",
  },
  {
    value: "RichText",
    label: "Rich Text",
    description: "Display a record's Rich Text field as a Document view.",
    icon: "mdi mdi-file-document-outline",
  },
  {
    value: "Subitem",
    label: "Subitem",
    description: "Display a record's Subitem(s) field as a view.",
    icon: "mdi mdi-group",
  },
];

const ViewSubViewTypeData = (isGlobalApp: boolean) => [
  ...ViewTypeData(false, isGlobalApp),
  ...SubViewTypeData,
];

interface Props {
  viewType: AllViewTypes | null;
  setViewType: Dispatch<SetStateAction<AllViewTypes | null>>;
  setField: Dispatch<SetStateAction<string>>;
  isSubView?: boolean;
  setPageNumber?: Dispatch<SetStateAction<number>>;
  globalAppID?: string | undefined;
}

export default function ViewTypeSection({
  viewType,
  setViewType,
  isSubView,
  setField,
  setPageNumber,
  globalAppID,
}: Props) {
  const isGlobalCloud = useAtomValue(isGlobalCloudAtom);
  const ViewTypes = isSubView
    ? ViewSubViewTypeData(!!globalAppID)
    : ViewTypeData(isGlobalCloud, !!globalAppID);

  const handleTypeChange = (newType: AllViewTypes) => {
    let number = 1;
    setField("");
    setViewType(newType);

    if (newType === "ReuseView") {
      number = 2;
    }

    setPageNumber && setPageNumber((prev) => prev + number);
  };

  return (
    <>
      {ViewTypes.map((typeData) => {
        return (
          // @ts-ignore
          <AppFieldCard
            full
            key={typeData.value}
            onClick={() => handleTypeChange(typeData.value as AllViewTypes)}
            isSelected={viewType === typeData.value}
            icon={typeData.icon}
            name={typeData.label}
            description={typeData.description}
            css="mb-2"
          />
        );
      })}
    </>
  );
}
